export default {
  common: {
    help: "Pomož",
  },
};
